import "core-js/modules/es.object.assign";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from 'react';
import ReactEcharts from 'echarts-for-react';
import clsx from 'clsx';
import i18n from '@pureartisan/simple-i18n';
import echarts from 'echarts/lib/echarts';
import { Col } from 'reactstrap';
import useStore from './../store';
import FeederLegendContent from './FeederLegendContent';

var FeederLegend = function FeederLegend(_ref) {
  var props = _extends({}, _ref); // Currently active (hovered) feeder
  // Stores the SLN of the feeder


  var activeFeeder = useStore(function (state) {
    return state.activeFeeder;
  });
  var feederLocked = useStore(function (state) {
    return state.feederLocked;
  });
  var breakpoint = useStore(function (state) {
    return state.breakpoint;
  }); // console.log('breakpoint, ', breakpoint)

  return /*#__PURE__*/React.createElement("div", {
    className: clsx('feeder-chart-legend', !!activeFeeder && !!feederLocked ? 'feeder-locked' : '')
  }, !!activeFeeder && !!feederLocked && breakpoint !== 'xs' && breakpoint !== 'sm' && breakpoint !== 'md' ? /*#__PURE__*/React.createElement(FeederLegendContent, null) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h2", null, i18n.translate('UI_FEEDER_TITLE_FEEDER_CHART')), /*#__PURE__*/React.createElement("div", {
    className: "feeder-desc",
    dangerouslySetInnerHTML: {
      __html: i18n.translate("UI_FEEDER_TITLE_FEEDER_DESC")
    }
  })));
};

export default FeederLegend;